import TYPES from '../../types';

// Domain
import { StateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';

type ChooseYourDocuments = {
  pocket_option_is_checked: boolean;
  wealth_option_is_checked: boolean;
  selected_investment_product_ids: Array<string>;
}

@Injectable()
export default class ChooseYourDocumentsService {
  @Inject(TYPES.CUSTOMER_ADDRESS_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  setChooseYourDocumentsData(choose_your_documents_data: ChooseYourDocuments): void {
    this.state_manager.state.choose_your_documents_data = { ...choose_your_documents_data };
  }

  getChooseYourDocumentsData(): ChooseYourDocuments {
    return this.state_manager.state.choose_your_documents_data;
  }
}
